var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlternativeTherapyRebrand = function SvgAlternativeTherapyRebrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Alternative-Therapy-rebrand_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F1F",
    d: "M23.262 12.729V0H12.71v12.729H0v10.542h12.729V36h10.542V23.271H36V12.729z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F1F",
    d: "M23.252 35.981V23.252h12.73V12.71h-12.73L12.71 23.252v12.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M22.215 6.392c-8.72 0-15.823 7.103-15.823 15.823v5.888l.757.747.748.757h5.888c8.72 0 15.822-7.102 15.822-15.822V6.411h-7.383v-.019z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M13.766 29.589c8.72 0 15.813-7.103 15.813-15.813V6.392L7.14 28.832l.757.757h5.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M14.832 16.944H12.72v6.327h6.327V21.16h-4.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M19.037 16.944V12.72h-2.112v6.336h6.327v-2.112z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "m23.841 12.14-.748-.757-16.72 16.72v1.486H7.86l16.72-16.72-.758-.748z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M19.196 21.112h-4.065l-2.028 2.028h6.093zM23.262 17.056h-4.066l-2.028 2.037h6.094z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "m24.598 12.87-.748-.748L6.392 29.57h1.496l16.71-16.71z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Alternative-Therapy-rebrand_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgAlternativeTherapyRebrand;